module.exports = __webpack_public_path__ + "img/47.7386aea9.png";